import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDmCoSoActionIds } from "../../action-types/category/IDmCoSoActions";
import { rootActions } from "../../actions/rootActions";
import { coSoApi } from "../../../api/category/coSoApi";

export function* coSoSaga(): any {
  yield takeLatest(eDmCoSoActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(coSoApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.coSo.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.coSo.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
